export const cashInvoicesType = {
  ADD_NOTE: "ADD_NOTE",
  NOTES_RECALCULATE: "NOTES_RECALCULATE",
  REMOVE_NOTE: "REMOVE_NOTE",
  UPDATE_RESUME: "UPDATE_RESUME",
  RESTORE_STATE: "RESTORE_STATE",

  GET_NOTE_UNIFICATION: "GET_NOTE_UNIFICATION",
  GET_BILLING_REASONS: "GET_BILLING_REASONS",
  GET_INVOICES_SERIES: "GET_INVOICES_SERIES",
  SET_INVOICE_DECIMAL: "SET_INVOICE_DECIMAL",
  DATA_SEND_MODE: "DATA_SEND_MODE",
  SET_DATA_TO_SEND: "SET_DATA_TO_SEND",
  RESTORE_INITIAL: "RESTORE_INITIAL",
  GET_SERIES: "GET_SERIES",
  CLEAR_SERIES_LIST: "CLEAR_SERIES_LIST",
  ERROR_GET_NOTE: "ERROR_GET_NOTE",
  CHANGE_REASON: "CHANGE_REASON",
  UPDATE_DATE_NOTE: "UPDATE_DATE_NOTE",
  RESTART_FORM: "RESTART_FORM",
}